import { fg } from '@atlaskit/platform-feature-flags';

const ISSUE_NAVIGATOR_URL = `/issues/?jql=${encodeURIComponent(
	'created >= -30d order by created DESC',
)}`;

const buildJiraJqlUrl = (jql: string, query: string) =>
	`/issues/?jql=${encodeURIComponent(jql)}&text=${encodeURIComponent(query)}`;

const buildJiraSearchUrl = (searchString: string) =>
	`/jira/search?${new URLSearchParams({ searchString }).toString()}`;

export const buildJiraAdvancedSearchPath: (query: string, jql?: string | null) => string = (query: string, jql?: string | null): string => {
	const trimmedQuery = query.trim();

	if (jql) {
		return buildJiraJqlUrl(jql, query);
	}

	if (trimmedQuery) {
		return buildJiraSearchUrl(trimmedQuery);
	}

	return ISSUE_NAVIGATOR_URL;
};

const buildRovoSearchUrl = (siteUrl?: string) => {
	const path = fg('jira_rovo_search_route_change')
		? '/jira/rovo-search'
		: '/jira/cross-product-search';

	if (!siteUrl) {
		return path;
	}
	return new URL(path, siteUrl || '').href;
};

// This function generates relative URL if base url is not available
export const generateJiraSearchUrl: (urlQueryParams: Record<string, string | string[] | boolean | undefined | null>, isSecondaryLink: boolean | undefined, customParams?: Record<string, string> | null) => string = (
	urlQueryParams: Record<string, string | string[] | boolean | undefined | null>,
	isSecondaryLink: boolean | undefined,
	customParams?: Record<string, string> | null,
) => {
	const searchParams = new URLSearchParams(customParams || {});

	// This function assumes the text is in sync with JQL text field
	let queryString = searchParams.get('text') || urlQueryParams.text?.toString() || '';
	const jql = searchParams.get('jql') || (!isSecondaryLink && urlQueryParams.jql?.toString()) || '';

	// remove jql from params as it's already picked up
	searchParams.delete('jql');

	if (!isSecondaryLink) {
		Object.entries(urlQueryParams).forEach(([key, value]) => {
			// add current params if they are not in custom search params
			if (value !== undefined && value !== null && !searchParams.has(key)) {
				searchParams.set(key, String(value));
			}
		});
	}

	let url = isSecondaryLink ? buildJiraAdvancedSearchPath(queryString, jql) : buildRovoSearchUrl();

	const params = searchParams.toString();
	if (params) {
		url = url.concat(url.includes('?') ? '&' : '?').concat(params);
	}

	return url;
};
